import moment from 'moment-timezone';
import _ from 'lodash';

export function checkScheduleTimeInBetween(allSchedules, ruleStartTime, ruleEndTime,
  selectedRuleStart = null, selectedRuleEnd = null) {
  const ruleStart = moment(ruleStartTime, "H:mm");
  const ruleEnd = moment(ruleEndTime, "H:mm");
  let timeInBtw = false;
  let schInBtw = false;
  // eslint-disable-next-line no-restricted-syntax
  for (const schedule of allSchedules) {
    const schStart = moment(schedule.timeStart, "H:mm");
    const schEnd = moment(schedule.timeEnd, "H:mm");
      const selectedRuleStartTime = selectedRuleStart && moment(selectedRuleStart, "H:mm");
      const selectedRuleEndTime = selectedRuleEnd && moment(selectedRuleEnd, "H:mm");
      if (selectedRuleStartTime) {
        schInBtw = selectedRuleStartTime.isSameOrAfter(schStart) && selectedRuleEndTime.isSameOrBefore(schEnd);
      }
      if (schInBtw) {
        timeInBtw = selectedRuleStartTime.isSameOrAfter(ruleStart) && selectedRuleEndTime.isSameOrBefore(ruleEnd);
        if (timeInBtw) {
          return true;
        }
      }
    }
    return timeInBtw;
  }

export function checkExclusiveRuleMatch (
  availableTimeslotRates,
      ruleSelectedDays,
      slotsRange,
      allSchedules,
      ruleStartTime,
      ruleEndTime,
      availableWeekdays,
      selectedWeekDays
    ) {
      let checkAllTime = false;
      let isExclusiveRuleMatch = false;
  
      // when all-timeslots selected for timeslot rules
      if (ruleStartTime === null) {
        checkAllTime = true;
      }
  
      const filteredSelectedWeekDays = new Set(selectedWeekDays);
      const filteredAvailableWeekdays = new Set(availableWeekdays);
      // eslint-disable-next-line no-restricted-syntax
      for (const rate of availableTimeslotRates) {
        let checkAllWeekDay = false;
        if (rate.exclusionRules.length === 0 && slotsRange.length === 0) {
          return false;
        }
  
        if (availableTimeslotRates.length > 0 && rate.exclusionRules.length === 0) {
          isExclusiveRuleMatch = true;
        }
        let ruleCheckLength = 0;
        let combinationWeekCheck = false;
        // eslint-disable-next-line no-restricted-syntax
        for (const rule of rate.exclusionRules) {
          const isWeekDayMatch = ruleSelectedDays.some(item => rule.value.includes(item));
          let isRuleSelectedDayMatch = false;
          if (selectedWeekDays.length > 0) {
            isRuleSelectedDayMatch = rule.value.some(day => filteredSelectedWeekDays.has(day));
          } else if (availableWeekdays.length > 0) {
            isRuleSelectedDayMatch = rule.value.some(day => filteredAvailableWeekdays.has(day));
          }
  
          checkAllWeekDay = isWeekDayMatch
            && (isRuleSelectedDayMatch || ((selectedWeekDays.length === 7 || selectedWeekDays.length === 0)
            && availableWeekdays.length === 0));
          if (rate.exclusionRules.length === 1) {
            //  either wday exist or time_range exist
            if (rule.type === "wday") {
              if (checkAllWeekDay) {
                isExclusiveRuleMatch = true;
              } else {
                checkAllTime = false;
              }
            } else if (rule.type === "time_range") {
              checkAllTime = checkScheduleTimeInBetween(allSchedules, ruleStartTime, ruleEndTime,
                rule.value[0], rule.value[1]);
            }
          } else if (rate.exclusionRules.length === 2) {
            // wday and time_range exist
            ruleCheckLength += 1;
            if (rule.type === "time_range") {
              checkAllTime = checkScheduleTimeInBetween(allSchedules, ruleStartTime, ruleEndTime,
                  rule.value[0], rule.value[1]);
            }
  
            if (ruleCheckLength === 2 && checkAllTime) {
              if (combinationWeekCheck) {
                isExclusiveRuleMatch = true;
              } else {
                checkAllTime = false;
              }
            }
  
            if (checkAllWeekDay && ruleCheckLength === 1) {
              combinationWeekCheck = true;
            }
          }
         
          if (isExclusiveRuleMatch && checkAllTime) {
            return { isExclusiveRuleMatch: true, timeInBetween: true };
          }
         }
      }
      return {isExclusiveRuleMatch, timeInBetween: checkAllTime};
    }

export function getAvailableScheduleSlots (
    startTimeRange,
    endDateRange,
    endTimeRange,
    slotsRange,
    ruleStartDate
  ) {
    let isScheduleSlotMatch = false;
    const availableTimeslots = [];
    const availableDates = [];
    const ruleStartTime = startTimeRange ? moment.utc(startTimeRange, 'h:mm A').format('HH:mm') : null;
    const ruleEndTime = endTimeRange ? moment.utc(endTimeRange, 'h:mm A').format('HH:mm') : null;
    slotsRange.forEach(slot => {
      const slotStart = moment.utc(slot.startAt);
      const slotEnd = moment.utc(slot.endAt);
      const slotDate = slotStart.format('YYYY-MM-DD');
      const slotEndDate = slotEnd.format('YYYY-MM-DD');
      const slotStartTime = slotStart.format('HH:mm');
      const slotEndTime = slotEnd.format('HH:mm');
      const isDateMatching = (moment(slotDate).isSameOrAfter(moment(ruleStartDate), 'day')) &&
        (!endDateRange || moment(slotDate).isSameOrBefore(moment(endDateRange), 'day'));
      const isTimeMatching = (!ruleStartTime || slotStartTime >= ruleStartTime) &&
        (!ruleEndTime || slotEndTime <= ruleEndTime);
      if (isDateMatching && isTimeMatching
        && (startTimeRange !== null && startTimeRange !== undefined )) {
          isScheduleSlotMatch = true;
      }
      if ((startTimeRange === null || startTimeRange === undefined) && isDateMatching) {
          isScheduleSlotMatch = true;
      } else if (isDateMatching && isTimeMatching) {
          isScheduleSlotMatch = true;
      }
      const findTimeslotIndex = availableTimeslots.findIndex(f => _.isEqual(f,
        { "timeStart": slotStartTime, "timeEnd": slotEndTime }));
      if(findTimeslotIndex === -1) {
        availableTimeslots.push({"timeStart": slotStartTime, "timeEnd": slotEndTime});
      }

      const findAvailableDateIndex = availableDates.findIndex(f => _.isEqual(f,
        { "slotStart": slotDate, "slotEnd": slotEndDate }));
      if (findAvailableDateIndex === -1) {
        availableDates.push({ "slotStart": slotDate, "slotEnd": slotEndDate });
      }
    });
    return { isScheduleSlotMatch, availableSlots: availableTimeslots, availableSlotDate: availableDates };
  }
